
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocationA as ObiLocationAElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-location-a.js';
 
 
 

 
 export const ObiLocationA = createComponent({
   react: React,
   tagName: 'obi-location-a',
   elementClass: ObiLocationAElement,
   events: {
     
   }
  });
 
 